import { z } from 'zod';
import { optionalMongoObjectId } from './object-id-helpers.js';

export const ChangeRequestSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    title: z.string().min(1, 'form.validation.nameRequired'),
    description: z.string().optional().or(z.literal('')),
    changeType: z.enum(['standard', 'normal', 'emergency']).default('normal'),
    status: z.enum(['draft', 'in_approval', 'approved', 'implemented', 'rejected', 'cancelled']).default('draft'),
    serviceCatalogItem: optionalMongoObjectId,
    plannedWindowStart: z.union([z.string(), z.date()]).optional().nullable(),
    plannedWindowEnd: z.union([z.string(), z.date()]).optional().nullable(),
    riskSummary: z.string().optional().or(z.literal('')),
    implementationResult: z.string().optional().or(z.literal('')),
    postImplementationReview: z.string().optional().or(z.literal('')),
    postImplementationReviewAt: z.union([z.string(), z.date()]).optional().nullable(),
    postImplementationReviewBy: optionalMongoObjectId,
});

export const CreateChangeRequestSchema = ChangeRequestSchema.omit({ id: true });
export const UpdateChangeRequestSchema = CreateChangeRequestSchema.partial();

export const SubmitChangeRequestApprovalSchema = z.object({
    /** @deprecated Ignored — ChangeRequest approvals use WorkflowTemplate only. */
    assignmentTemplate: z.string().optional(),
}).passthrough();
